(() => {
  const init = () => {
    document.querySelectorAll('[data-offer-link]').forEach((link) => {
      if (link.dataset.ready === 'true') return;
      link.dataset.ready = 'true';
      link.addEventListener('click', (event) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({behavior: reduceMotion ? 'auto' : 'smooth', block: 'start'});
        target.classList.remove('is-selected');
        requestAnimationFrame(() => target.classList.add('is-selected'));
        window.history.replaceState(null, '', link.getAttribute('href'));
        window.setTimeout(() => target.classList.remove('is-selected'), reduceMotion ? 0 : 1800);
      });
    });

    document.querySelectorAll('[data-bundle-card]').forEach((card) => {
      const button = card.querySelector('[data-bundle-add]');
      if (!button || button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';

      const primary = card.querySelector('[data-bundle-variant="primary"]');
      const gift = card.querySelector('[data-bundle-variant="gift"]');
      const giftQuantity = card.querySelector('[data-bundle-quantity="gift"]');
      const status = card.querySelector('[data-bundle-status]');

      const selectedGiftPackSize = () => {
        if (!gift || gift.tagName !== 'SELECT') return 1;
        const selectedOption = gift.options[gift.selectedIndex];
        return Number(selectedOption?.dataset.packSize || 1);
      };

      const syncJackBlockQuantity = () => {
        if (card.id !== 'offer-ultimate' || !giftQuantity) return;
        const packSize = selectedGiftPackSize();
        const maximumQuantity = packSize > 0 ? Math.max(1, Math.floor(6 / packSize)) : 1;
        const previousQuantity = Number(giftQuantity.value || 1);
        const selectedQuantity = Math.min(Math.max(previousQuantity, 1), maximumQuantity);
        const options = [];
        for (let quantity = 1; quantity <= maximumQuantity; quantity += 1) {
          options.push(new Option(String(quantity), String(quantity), false, quantity === selectedQuantity));
        }
        giftQuantity.replaceChildren(...options);
        giftQuantity.value = String(selectedQuantity);
        giftQuantity.setAttribute('aria-label', `Choose up to ${maximumQuantity} ${maximumQuantity === 1 ? 'pack' : 'packs'}, six Jack Blocks maximum`);
      };

      const syncRapidHitchImage = () => {
        if (card.id !== 'offer-rapid' || !primary || primary.tagName !== 'SELECT') return;
        const image = card.querySelector('[data-primary-product-image] img');
        const selectedOption = primary.options[primary.selectedIndex];
        if (!image || !selectedOption?.dataset.imageSrc) return;
        if (selectedOption.dataset.imageSrcset) {
          image.srcset = selectedOption.dataset.imageSrcset;
        } else {
          image.removeAttribute('srcset');
        }
        image.src = selectedOption.dataset.imageSrc;
        image.alt = selectedOption.dataset.imageAlt || 'Selected Rapid Hitch';
      };

      primary?.addEventListener('change', syncRapidHitchImage);
      gift?.addEventListener('change', syncJackBlockQuantity);
      syncRapidHitchImage();
      syncJackBlockQuantity();

      button.addEventListener('click', async () => {
        if (!primary?.value || !gift?.value) return;

        button.disabled = true;
        button.classList.add('is-loading');
        button.textContent = 'Adding bundle…';
        status.textContent = '';
        status.classList.remove('is-error');

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            body: JSON.stringify({items: [
              {id: Number(primary.value), quantity: 1},
              {id: Number(gift.value), quantity: Number(giftQuantity?.value || 1)}
            ]})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'This bundle could not be added.');

          status.textContent = 'Bundle added. Your automatic savings will appear in cart or checkout.';
          document.dispatchEvent(new CustomEvent('cart:item-add', {detail: {items: result.items, context: 'LaborDayBundle'}}));
          window.location.href = `${root}cart`;
        } catch (error) {
          status.textContent = error.message || 'Something went wrong. Please try again.';
          status.classList.add('is-error');
        } finally {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.innerHTML = button.dataset.originalHtml;
        }
      });
      button.dataset.originalHtml = button.innerHTML;
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
